import i18next from 'i18next'
import I18NextVue from 'i18next-vue'
import Backend from 'i18next-http-backend';

export const SUPPORTED_LOCALES = ['en'];
export const FALLBACK_LOCALE = 'en';

const debug = import.meta.env.VITE_TRANSLATE_DEBUG;
const appUrl = import.meta.env.VITE_BASE_URL ? import.meta.env.VITE_BASE_URL : 'http://localhost:5173';

const backendOptions = {
    loadPath: appUrl + '/locales/{{lng}}/{{ns}}.json',
    // addPath: appUrl + '/locales/add/{{lng}}/{{ns}}'
};

export default async function (app) {

    await i18next.use(Backend).init({
        ns: ['common'],
        defaultNS: 'common',
        load: 'languageOnly',
        // preload: ['en'],
        // debug: false,
        debug,
        // lng:  (locale.trim().length && locale !== "/") ? locale : 'en',
        fallbackLng: FALLBACK_LOCALE,
        saveMissing: false,
        detection: {convertDetectedLanguage: lang => lang.substring(0, 2)},
        backend: backendOptions
        // supportedLngs: ['en', 'lt', 'ru']
    });

    app.use(I18NextVue, {i18next});
    return app
}